export default "__VITE_ASSET__21AkvwyE__"